"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadMotivationalLetterField = UploadMotivationalLetterField;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
function UploadMotivationalLetterField({ motivationalLetterRules, motivationalLetterFileList, setMotivationalLetterFileList, }) {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
            id: 'offer_detail.send_resume_form.motivational_letter',
        }), name: "motivationalLetter", "data-cy": "motivation-letter", rules: motivationalLetterRules, children: (0, jsx_runtime_1.jsx)(elements_1.FileUpload, { name: "motivationalLetter", accept: "*", maxFileSize: 2, multiple: false, wholeFileList: motivationalLetterFileList, setFileList: setMotivationalLetterFileList }) }));
}
